import React, {Component} from 'react';
import {
  Button,
  Dimmer,
  Form,
  Input,
  Loader,
  Message,
}                         from 'semantic-ui-react';
import PropTypes          from 'prop-types';
import memobind           from 'memobind';
import {withRouter}       from 'react-router';

// Controller
import globalController from '../../global/globalcontroller';

// Style
import './MainLogin.scss';

const propTypes = {
  isLoadingLogin : PropTypes.bool,
  location       : PropTypes.shape({pathname: PropTypes.string}).isRequired,
  login          : PropTypes.func.isRequired,
  onClose        : PropTypes.func.isRequired,
  setToken       : PropTypes.func.isRequired,
};

const defaultProps = {isLoadingLogin: false};

class MainLogin extends Component {

  constructor(props) {
    super(props);
    this.state = {
      username : '',
      password : '',
      error    : '',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const {
      location : {pathname},
      onClose,
      setToken,
    } = this.props;

    if (pathname !== '/gaelle') {
      this.props.onClose();
    }
    else {
      const cookie = setToken();
      if (cookie) {
        onClose();
      }
    }
  }

  handleSubmit() {
    this.props.login(this.state)
      .then(() => {
        this.props.onClose();
      })
      .catch((err) => {
        this.setState({error: err}, () => {
          setTimeout(() => {
            this.setState({error: ''});
          }, 3000);
        });
      });
  }

  handleChange(type, e, data) {
    this.setState({[type]: data.value});
  }

  render() {
    const {isLoadingLogin} = this.props;

    return (
      <div className='MainLogin'>
        {isLoadingLogin &&
          <Dimmer active>
            <Loader size='huge'>{'Loading'}</Loader>
          </Dimmer>
        }

        <Form>
          <Form.Field>
            <Input
              label='Username'
              onChange={memobind(this, 'handleChange', 'username')}
              type='text'
            />
          </Form.Field>
          <Form.Field>
            <Input
              label='Password'
              onChange={memobind(this, 'handleChange', 'password')}
              type='password'
            />
          </Form.Field>
          <Button
            onClick={this.handleSubmit}
            type='submit'
          >
            {'Submit'}
          </Button>
          {
            this.state.error &&
            <Message
              color='red'
              content={this.state.error}
              icon='warning sign'
            />
          }
        </Form>
      </div>
    );

    return null;
  }

}

MainLogin.propTypes = propTypes;

MainLogin.defaultProps = defaultProps;

export default globalController(withRouter(MainLogin));



// WEBPACK FOOTER //
// ./src/organisms/MainLogin/MainLogin.js